/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from "@tanstack/react-router"

import { Route as rootRouteImport } from "./routes/__root"
import { Route as TwoFactorRouteImport } from "./routes/two-factor"
import { Route as SignOutRouteImport } from "./routes/sign-out"
import { Route as SignInRouteImport } from "./routes/sign-in"
import { Route as AuthedRouteRouteImport } from "./routes/_authed/route"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as OnboardingTokenRouteImport } from "./routes/onboarding/$token"
import { Route as AuthedDashboardRouteImport } from "./routes/_authed/dashboard"
import { Route as AuthedWorkRouteRouteImport } from "./routes/_authed/work/route"
import { Route as AuthedWorkIndexRouteImport } from "./routes/_authed/work/index"
import { Route as AuthedWorkInboxRouteImport } from "./routes/_authed/work/inbox"
import { Route as AuthedWorkChangesRouteImport } from "./routes/_authed/work/changes"
import { Route as AuthedOnboardingMfaRouteImport } from "./routes/_authed/onboarding/mfa"
import { Route as AuthedAdminUsersRouteImport } from "./routes/_authed/admin/users"
import { Route as AuthedAdminUrenRouteImport } from "./routes/_authed/admin/uren"
import { Route as AuthedAdminTranslationsRouteImport } from "./routes/_authed/admin/translations"
import { Route as AuthedAdminStyleguideRouteImport } from "./routes/_authed/admin/styleguide"
import { Route as AuthedAdminReplacementsRouteImport } from "./routes/_authed/admin/replacements"
import { Route as AuthedAdminHolidaysRouteImport } from "./routes/_authed/admin/holidays"
import { Route as AuthedAdminEmailTemplatesRouteImport } from "./routes/_authed/admin/email-templates"
import { Route as AuthedAdminAuditLogRouteImport } from "./routes/_authed/admin/audit-log"
import { Route as AuthedAdminAppSettingsRouteImport } from "./routes/_authed/admin/app-settings"
import { Route as AuthedAdminAddressesRouteImport } from "./routes/_authed/admin/addresses"
import { Route as AuthedWorkNewRouteRouteImport } from "./routes/_authed/work/new/route"
import { Route as AuthedWorkNewTypeRouteImport } from "./routes/_authed/work/new/type"
import { Route as AuthedWorkDayDateRouteImport } from "./routes/_authed/work/day/$date"
import { Route as AuthedAdminEmailTemplatesTemplateKeyRouteImport } from "./routes/_authed/admin/email-templates.$templateKey"
import { Route as AuthedAdminUrenEntryIdEditRouteImport } from "./routes/_authed/admin/uren.$entryId.edit"

const AuthedWorkTripIdLazyRouteImport = createFileRoute(
  "/_authed/work/trip/$id",
)()
const AuthedWorkNewWorkLazyRouteImport = createFileRoute(
  "/_authed/work/new/work",
)()
const AuthedWorkNewTravelLazyRouteImport = createFileRoute(
  "/_authed/work/new/travel",
)()
const AuthedWorkNewNoWorkLazyRouteImport = createFileRoute(
  "/_authed/work/new/no-work",
)()
const AuthedWorkLodgingIdLazyRouteImport = createFileRoute(
  "/_authed/work/lodging/$id",
)()
const AuthedWorkAttachmentsIdLazyRouteImport = createFileRoute(
  "/_authed/work/attachments/$id",
)()
const AuthedWorkLodgingIdInvoiceLazyRouteImport = createFileRoute(
  "/_authed/work/lodging/$id/invoice",
)()

const TwoFactorRoute = TwoFactorRouteImport.update({
  id: "/two-factor",
  path: "/two-factor",
  getParentRoute: () => rootRouteImport,
} as any)
const SignOutRoute = SignOutRouteImport.update({
  id: "/sign-out",
  path: "/sign-out",
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: "/sign-in",
  path: "/sign-in",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRouteRoute = AuthedRouteRouteImport.update({
  id: "/_authed",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingTokenRoute = OnboardingTokenRouteImport.update({
  id: "/onboarding/$token",
  path: "/onboarding/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedWorkRouteRoute = AuthedWorkRouteRouteImport.update({
  id: "/work",
  path: "/work",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedWorkIndexRoute = AuthedWorkIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedWorkRouteRoute,
} as any)
const AuthedWorkInboxRoute = AuthedWorkInboxRouteImport.update({
  id: "/inbox",
  path: "/inbox",
  getParentRoute: () => AuthedWorkRouteRoute,
} as any)
const AuthedWorkChangesRoute = AuthedWorkChangesRouteImport.update({
  id: "/changes",
  path: "/changes",
  getParentRoute: () => AuthedWorkRouteRoute,
} as any)
const AuthedOnboardingMfaRoute = AuthedOnboardingMfaRouteImport.update({
  id: "/onboarding/mfa",
  path: "/onboarding/mfa",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAdminUsersRoute = AuthedAdminUsersRouteImport.update({
  id: "/admin/users",
  path: "/admin/users",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAdminUrenRoute = AuthedAdminUrenRouteImport.update({
  id: "/admin/uren",
  path: "/admin/uren",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAdminTranslationsRoute = AuthedAdminTranslationsRouteImport.update({
  id: "/admin/translations",
  path: "/admin/translations",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAdminStyleguideRoute = AuthedAdminStyleguideRouteImport.update({
  id: "/admin/styleguide",
  path: "/admin/styleguide",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAdminReplacementsRoute = AuthedAdminReplacementsRouteImport.update({
  id: "/admin/replacements",
  path: "/admin/replacements",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAdminHolidaysRoute = AuthedAdminHolidaysRouteImport.update({
  id: "/admin/holidays",
  path: "/admin/holidays",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAdminEmailTemplatesRoute =
  AuthedAdminEmailTemplatesRouteImport.update({
    id: "/admin/email-templates",
    path: "/admin/email-templates",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedAdminAuditLogRoute = AuthedAdminAuditLogRouteImport.update({
  id: "/admin/audit-log",
  path: "/admin/audit-log",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAdminAppSettingsRoute = AuthedAdminAppSettingsRouteImport.update({
  id: "/admin/app-settings",
  path: "/admin/app-settings",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAdminAddressesRoute = AuthedAdminAddressesRouteImport.update({
  id: "/admin/addresses",
  path: "/admin/addresses",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedWorkNewRouteRoute = AuthedWorkNewRouteRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => AuthedWorkRouteRoute,
} as any)
const AuthedWorkTripIdLazyRoute = AuthedWorkTripIdLazyRouteImport.update({
  id: "/trip/$id",
  path: "/trip/$id",
  getParentRoute: () => AuthedWorkRouteRoute,
} as any).lazy(() =>
  import("./routes/_authed/work/trip/$id.lazy").then((d) => d.Route),
)
const AuthedWorkNewWorkLazyRoute = AuthedWorkNewWorkLazyRouteImport.update({
  id: "/work",
  path: "/work",
  getParentRoute: () => AuthedWorkNewRouteRoute,
} as any).lazy(() =>
  import("./routes/_authed/work/new/work.lazy").then((d) => d.Route),
)
const AuthedWorkNewTravelLazyRoute = AuthedWorkNewTravelLazyRouteImport.update({
  id: "/travel",
  path: "/travel",
  getParentRoute: () => AuthedWorkNewRouteRoute,
} as any).lazy(() =>
  import("./routes/_authed/work/new/travel.lazy").then((d) => d.Route),
)
const AuthedWorkNewNoWorkLazyRoute = AuthedWorkNewNoWorkLazyRouteImport.update({
  id: "/no-work",
  path: "/no-work",
  getParentRoute: () => AuthedWorkNewRouteRoute,
} as any).lazy(() =>
  import("./routes/_authed/work/new/no-work.lazy").then((d) => d.Route),
)
const AuthedWorkLodgingIdLazyRoute = AuthedWorkLodgingIdLazyRouteImport.update({
  id: "/lodging/$id",
  path: "/lodging/$id",
  getParentRoute: () => AuthedWorkRouteRoute,
} as any).lazy(() =>
  import("./routes/_authed/work/lodging/$id.lazy").then((d) => d.Route),
)
const AuthedWorkAttachmentsIdLazyRoute =
  AuthedWorkAttachmentsIdLazyRouteImport.update({
    id: "/attachments/$id",
    path: "/attachments/$id",
    getParentRoute: () => AuthedWorkRouteRoute,
  } as any).lazy(() =>
    import("./routes/_authed/work/attachments/$id.lazy").then((d) => d.Route),
  )
const AuthedWorkNewTypeRoute = AuthedWorkNewTypeRouteImport.update({
  id: "/type",
  path: "/type",
  getParentRoute: () => AuthedWorkNewRouteRoute,
} as any)
const AuthedWorkDayDateRoute = AuthedWorkDayDateRouteImport.update({
  id: "/day/$date",
  path: "/day/$date",
  getParentRoute: () => AuthedWorkRouteRoute,
} as any)
const AuthedAdminEmailTemplatesTemplateKeyRoute =
  AuthedAdminEmailTemplatesTemplateKeyRouteImport.update({
    id: "/$templateKey",
    path: "/$templateKey",
    getParentRoute: () => AuthedAdminEmailTemplatesRoute,
  } as any)
const AuthedWorkLodgingIdInvoiceLazyRoute =
  AuthedWorkLodgingIdInvoiceLazyRouteImport.update({
    id: "/invoice",
    path: "/invoice",
    getParentRoute: () => AuthedWorkLodgingIdLazyRoute,
  } as any).lazy(() =>
    import("./routes/_authed/work/lodging/$id.invoice.lazy").then(
      (d) => d.Route,
    ),
  )
const AuthedAdminUrenEntryIdEditRoute =
  AuthedAdminUrenEntryIdEditRouteImport.update({
    id: "/$entryId/edit",
    path: "/$entryId/edit",
    getParentRoute: () => AuthedAdminUrenRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/sign-in": typeof SignInRoute
  "/sign-out": typeof SignOutRoute
  "/two-factor": typeof TwoFactorRoute
  "/work": typeof AuthedWorkRouteRouteWithChildren
  "/dashboard": typeof AuthedDashboardRoute
  "/onboarding/$token": typeof OnboardingTokenRoute
  "/work/new": typeof AuthedWorkNewRouteRouteWithChildren
  "/admin/addresses": typeof AuthedAdminAddressesRoute
  "/admin/app-settings": typeof AuthedAdminAppSettingsRoute
  "/admin/audit-log": typeof AuthedAdminAuditLogRoute
  "/admin/email-templates": typeof AuthedAdminEmailTemplatesRouteWithChildren
  "/admin/holidays": typeof AuthedAdminHolidaysRoute
  "/admin/replacements": typeof AuthedAdminReplacementsRoute
  "/admin/styleguide": typeof AuthedAdminStyleguideRoute
  "/admin/translations": typeof AuthedAdminTranslationsRoute
  "/admin/uren": typeof AuthedAdminUrenRouteWithChildren
  "/admin/users": typeof AuthedAdminUsersRoute
  "/onboarding/mfa": typeof AuthedOnboardingMfaRoute
  "/work/changes": typeof AuthedWorkChangesRoute
  "/work/inbox": typeof AuthedWorkInboxRoute
  "/work/": typeof AuthedWorkIndexRoute
  "/admin/email-templates/$templateKey": typeof AuthedAdminEmailTemplatesTemplateKeyRoute
  "/work/day/$date": typeof AuthedWorkDayDateRoute
  "/work/new/type": typeof AuthedWorkNewTypeRoute
  "/work/attachments/$id": typeof AuthedWorkAttachmentsIdLazyRoute
  "/work/lodging/$id": typeof AuthedWorkLodgingIdLazyRouteWithChildren
  "/work/new/no-work": typeof AuthedWorkNewNoWorkLazyRoute
  "/work/new/travel": typeof AuthedWorkNewTravelLazyRoute
  "/work/new/work": typeof AuthedWorkNewWorkLazyRoute
  "/work/trip/$id": typeof AuthedWorkTripIdLazyRoute
  "/admin/uren/$entryId/edit": typeof AuthedAdminUrenEntryIdEditRoute
  "/work/lodging/$id/invoice": typeof AuthedWorkLodgingIdInvoiceLazyRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/sign-in": typeof SignInRoute
  "/sign-out": typeof SignOutRoute
  "/two-factor": typeof TwoFactorRoute
  "/dashboard": typeof AuthedDashboardRoute
  "/onboarding/$token": typeof OnboardingTokenRoute
  "/work/new": typeof AuthedWorkNewRouteRouteWithChildren
  "/admin/addresses": typeof AuthedAdminAddressesRoute
  "/admin/app-settings": typeof AuthedAdminAppSettingsRoute
  "/admin/audit-log": typeof AuthedAdminAuditLogRoute
  "/admin/email-templates": typeof AuthedAdminEmailTemplatesRouteWithChildren
  "/admin/holidays": typeof AuthedAdminHolidaysRoute
  "/admin/replacements": typeof AuthedAdminReplacementsRoute
  "/admin/styleguide": typeof AuthedAdminStyleguideRoute
  "/admin/translations": typeof AuthedAdminTranslationsRoute
  "/admin/uren": typeof AuthedAdminUrenRouteWithChildren
  "/admin/users": typeof AuthedAdminUsersRoute
  "/onboarding/mfa": typeof AuthedOnboardingMfaRoute
  "/work/changes": typeof AuthedWorkChangesRoute
  "/work/inbox": typeof AuthedWorkInboxRoute
  "/work": typeof AuthedWorkIndexRoute
  "/admin/email-templates/$templateKey": typeof AuthedAdminEmailTemplatesTemplateKeyRoute
  "/work/day/$date": typeof AuthedWorkDayDateRoute
  "/work/new/type": typeof AuthedWorkNewTypeRoute
  "/work/attachments/$id": typeof AuthedWorkAttachmentsIdLazyRoute
  "/work/lodging/$id": typeof AuthedWorkLodgingIdLazyRouteWithChildren
  "/work/new/no-work": typeof AuthedWorkNewNoWorkLazyRoute
  "/work/new/travel": typeof AuthedWorkNewTravelLazyRoute
  "/work/new/work": typeof AuthedWorkNewWorkLazyRoute
  "/work/trip/$id": typeof AuthedWorkTripIdLazyRoute
  "/admin/uren/$entryId/edit": typeof AuthedAdminUrenEntryIdEditRoute
  "/work/lodging/$id/invoice": typeof AuthedWorkLodgingIdInvoiceLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/_authed": typeof AuthedRouteRouteWithChildren
  "/sign-in": typeof SignInRoute
  "/sign-out": typeof SignOutRoute
  "/two-factor": typeof TwoFactorRoute
  "/_authed/work": typeof AuthedWorkRouteRouteWithChildren
  "/_authed/dashboard": typeof AuthedDashboardRoute
  "/onboarding/$token": typeof OnboardingTokenRoute
  "/_authed/work/new": typeof AuthedWorkNewRouteRouteWithChildren
  "/_authed/admin/addresses": typeof AuthedAdminAddressesRoute
  "/_authed/admin/app-settings": typeof AuthedAdminAppSettingsRoute
  "/_authed/admin/audit-log": typeof AuthedAdminAuditLogRoute
  "/_authed/admin/email-templates": typeof AuthedAdminEmailTemplatesRouteWithChildren
  "/_authed/admin/holidays": typeof AuthedAdminHolidaysRoute
  "/_authed/admin/replacements": typeof AuthedAdminReplacementsRoute
  "/_authed/admin/styleguide": typeof AuthedAdminStyleguideRoute
  "/_authed/admin/translations": typeof AuthedAdminTranslationsRoute
  "/_authed/admin/uren": typeof AuthedAdminUrenRouteWithChildren
  "/_authed/admin/users": typeof AuthedAdminUsersRoute
  "/_authed/onboarding/mfa": typeof AuthedOnboardingMfaRoute
  "/_authed/work/changes": typeof AuthedWorkChangesRoute
  "/_authed/work/inbox": typeof AuthedWorkInboxRoute
  "/_authed/work/": typeof AuthedWorkIndexRoute
  "/_authed/admin/email-templates/$templateKey": typeof AuthedAdminEmailTemplatesTemplateKeyRoute
  "/_authed/work/day/$date": typeof AuthedWorkDayDateRoute
  "/_authed/work/new/type": typeof AuthedWorkNewTypeRoute
  "/_authed/work/attachments/$id": typeof AuthedWorkAttachmentsIdLazyRoute
  "/_authed/work/lodging/$id": typeof AuthedWorkLodgingIdLazyRouteWithChildren
  "/_authed/work/new/no-work": typeof AuthedWorkNewNoWorkLazyRoute
  "/_authed/work/new/travel": typeof AuthedWorkNewTravelLazyRoute
  "/_authed/work/new/work": typeof AuthedWorkNewWorkLazyRoute
  "/_authed/work/trip/$id": typeof AuthedWorkTripIdLazyRoute
  "/_authed/admin/uren/$entryId/edit": typeof AuthedAdminUrenEntryIdEditRoute
  "/_authed/work/lodging/$id/invoice": typeof AuthedWorkLodgingIdInvoiceLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/sign-in"
    | "/sign-out"
    | "/two-factor"
    | "/work"
    | "/dashboard"
    | "/onboarding/$token"
    | "/work/new"
    | "/admin/addresses"
    | "/admin/app-settings"
    | "/admin/audit-log"
    | "/admin/email-templates"
    | "/admin/holidays"
    | "/admin/replacements"
    | "/admin/styleguide"
    | "/admin/translations"
    | "/admin/uren"
    | "/admin/users"
    | "/onboarding/mfa"
    | "/work/changes"
    | "/work/inbox"
    | "/work/"
    | "/admin/email-templates/$templateKey"
    | "/work/day/$date"
    | "/work/new/type"
    | "/work/attachments/$id"
    | "/work/lodging/$id"
    | "/work/new/no-work"
    | "/work/new/travel"
    | "/work/new/work"
    | "/work/trip/$id"
    | "/admin/uren/$entryId/edit"
    | "/work/lodging/$id/invoice"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/sign-in"
    | "/sign-out"
    | "/two-factor"
    | "/dashboard"
    | "/onboarding/$token"
    | "/work/new"
    | "/admin/addresses"
    | "/admin/app-settings"
    | "/admin/audit-log"
    | "/admin/email-templates"
    | "/admin/holidays"
    | "/admin/replacements"
    | "/admin/styleguide"
    | "/admin/translations"
    | "/admin/uren"
    | "/admin/users"
    | "/onboarding/mfa"
    | "/work/changes"
    | "/work/inbox"
    | "/work"
    | "/admin/email-templates/$templateKey"
    | "/work/day/$date"
    | "/work/new/type"
    | "/work/attachments/$id"
    | "/work/lodging/$id"
    | "/work/new/no-work"
    | "/work/new/travel"
    | "/work/new/work"
    | "/work/trip/$id"
    | "/admin/uren/$entryId/edit"
    | "/work/lodging/$id/invoice"
  id:
    | "__root__"
    | "/"
    | "/_authed"
    | "/sign-in"
    | "/sign-out"
    | "/two-factor"
    | "/_authed/work"
    | "/_authed/dashboard"
    | "/onboarding/$token"
    | "/_authed/work/new"
    | "/_authed/admin/addresses"
    | "/_authed/admin/app-settings"
    | "/_authed/admin/audit-log"
    | "/_authed/admin/email-templates"
    | "/_authed/admin/holidays"
    | "/_authed/admin/replacements"
    | "/_authed/admin/styleguide"
    | "/_authed/admin/translations"
    | "/_authed/admin/uren"
    | "/_authed/admin/users"
    | "/_authed/onboarding/mfa"
    | "/_authed/work/changes"
    | "/_authed/work/inbox"
    | "/_authed/work/"
    | "/_authed/admin/email-templates/$templateKey"
    | "/_authed/work/day/$date"
    | "/_authed/work/new/type"
    | "/_authed/work/attachments/$id"
    | "/_authed/work/lodging/$id"
    | "/_authed/work/new/no-work"
    | "/_authed/work/new/travel"
    | "/_authed/work/new/work"
    | "/_authed/work/trip/$id"
    | "/_authed/admin/uren/$entryId/edit"
    | "/_authed/work/lodging/$id/invoice"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRouteRoute: typeof AuthedRouteRouteWithChildren
  SignInRoute: typeof SignInRoute
  SignOutRoute: typeof SignOutRoute
  TwoFactorRoute: typeof TwoFactorRoute
  OnboardingTokenRoute: typeof OnboardingTokenRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/two-factor": {
      id: "/two-factor"
      path: "/two-factor"
      fullPath: "/two-factor"
      preLoaderRoute: typeof TwoFactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/sign-out": {
      id: "/sign-out"
      path: "/sign-out"
      fullPath: "/sign-out"
      preLoaderRoute: typeof SignOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/sign-in": {
      id: "/sign-in"
      path: "/sign-in"
      fullPath: "/sign-in"
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed": {
      id: "/_authed"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/onboarding/$token": {
      id: "/onboarding/$token"
      path: "/onboarding/$token"
      fullPath: "/onboarding/$token"
      preLoaderRoute: typeof OnboardingTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed/dashboard": {
      id: "/_authed/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/work": {
      id: "/_authed/work"
      path: "/work"
      fullPath: "/work"
      preLoaderRoute: typeof AuthedWorkRouteRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/work/": {
      id: "/_authed/work/"
      path: "/"
      fullPath: "/work/"
      preLoaderRoute: typeof AuthedWorkIndexRouteImport
      parentRoute: typeof AuthedWorkRouteRoute
    }
    "/_authed/work/inbox": {
      id: "/_authed/work/inbox"
      path: "/inbox"
      fullPath: "/work/inbox"
      preLoaderRoute: typeof AuthedWorkInboxRouteImport
      parentRoute: typeof AuthedWorkRouteRoute
    }
    "/_authed/work/changes": {
      id: "/_authed/work/changes"
      path: "/changes"
      fullPath: "/work/changes"
      preLoaderRoute: typeof AuthedWorkChangesRouteImport
      parentRoute: typeof AuthedWorkRouteRoute
    }
    "/_authed/onboarding/mfa": {
      id: "/_authed/onboarding/mfa"
      path: "/onboarding/mfa"
      fullPath: "/onboarding/mfa"
      preLoaderRoute: typeof AuthedOnboardingMfaRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/admin/users": {
      id: "/_authed/admin/users"
      path: "/admin/users"
      fullPath: "/admin/users"
      preLoaderRoute: typeof AuthedAdminUsersRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/admin/uren": {
      id: "/_authed/admin/uren"
      path: "/admin/uren"
      fullPath: "/admin/uren"
      preLoaderRoute: typeof AuthedAdminUrenRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/admin/translations": {
      id: "/_authed/admin/translations"
      path: "/admin/translations"
      fullPath: "/admin/translations"
      preLoaderRoute: typeof AuthedAdminTranslationsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/admin/styleguide": {
      id: "/_authed/admin/styleguide"
      path: "/admin/styleguide"
      fullPath: "/admin/styleguide"
      preLoaderRoute: typeof AuthedAdminStyleguideRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/admin/replacements": {
      id: "/_authed/admin/replacements"
      path: "/admin/replacements"
      fullPath: "/admin/replacements"
      preLoaderRoute: typeof AuthedAdminReplacementsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/admin/holidays": {
      id: "/_authed/admin/holidays"
      path: "/admin/holidays"
      fullPath: "/admin/holidays"
      preLoaderRoute: typeof AuthedAdminHolidaysRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/admin/email-templates": {
      id: "/_authed/admin/email-templates"
      path: "/admin/email-templates"
      fullPath: "/admin/email-templates"
      preLoaderRoute: typeof AuthedAdminEmailTemplatesRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/admin/audit-log": {
      id: "/_authed/admin/audit-log"
      path: "/admin/audit-log"
      fullPath: "/admin/audit-log"
      preLoaderRoute: typeof AuthedAdminAuditLogRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/admin/app-settings": {
      id: "/_authed/admin/app-settings"
      path: "/admin/app-settings"
      fullPath: "/admin/app-settings"
      preLoaderRoute: typeof AuthedAdminAppSettingsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/admin/addresses": {
      id: "/_authed/admin/addresses"
      path: "/admin/addresses"
      fullPath: "/admin/addresses"
      preLoaderRoute: typeof AuthedAdminAddressesRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/work/new": {
      id: "/_authed/work/new"
      path: "/new"
      fullPath: "/work/new"
      preLoaderRoute: typeof AuthedWorkNewRouteRouteImport
      parentRoute: typeof AuthedWorkRouteRoute
    }
    "/_authed/work/trip/$id": {
      id: "/_authed/work/trip/$id"
      path: "/trip/$id"
      fullPath: "/work/trip/$id"
      preLoaderRoute: typeof AuthedWorkTripIdLazyRouteImport
      parentRoute: typeof AuthedWorkRouteRoute
    }
    "/_authed/work/new/work": {
      id: "/_authed/work/new/work"
      path: "/work"
      fullPath: "/work/new/work"
      preLoaderRoute: typeof AuthedWorkNewWorkLazyRouteImport
      parentRoute: typeof AuthedWorkNewRouteRoute
    }
    "/_authed/work/new/travel": {
      id: "/_authed/work/new/travel"
      path: "/travel"
      fullPath: "/work/new/travel"
      preLoaderRoute: typeof AuthedWorkNewTravelLazyRouteImport
      parentRoute: typeof AuthedWorkNewRouteRoute
    }
    "/_authed/work/new/no-work": {
      id: "/_authed/work/new/no-work"
      path: "/no-work"
      fullPath: "/work/new/no-work"
      preLoaderRoute: typeof AuthedWorkNewNoWorkLazyRouteImport
      parentRoute: typeof AuthedWorkNewRouteRoute
    }
    "/_authed/work/lodging/$id": {
      id: "/_authed/work/lodging/$id"
      path: "/lodging/$id"
      fullPath: "/work/lodging/$id"
      preLoaderRoute: typeof AuthedWorkLodgingIdLazyRouteImport
      parentRoute: typeof AuthedWorkRouteRoute
    }
    "/_authed/work/attachments/$id": {
      id: "/_authed/work/attachments/$id"
      path: "/attachments/$id"
      fullPath: "/work/attachments/$id"
      preLoaderRoute: typeof AuthedWorkAttachmentsIdLazyRouteImport
      parentRoute: typeof AuthedWorkRouteRoute
    }
    "/_authed/work/new/type": {
      id: "/_authed/work/new/type"
      path: "/type"
      fullPath: "/work/new/type"
      preLoaderRoute: typeof AuthedWorkNewTypeRouteImport
      parentRoute: typeof AuthedWorkNewRouteRoute
    }
    "/_authed/work/day/$date": {
      id: "/_authed/work/day/$date"
      path: "/day/$date"
      fullPath: "/work/day/$date"
      preLoaderRoute: typeof AuthedWorkDayDateRouteImport
      parentRoute: typeof AuthedWorkRouteRoute
    }
    "/_authed/admin/email-templates/$templateKey": {
      id: "/_authed/admin/email-templates/$templateKey"
      path: "/$templateKey"
      fullPath: "/admin/email-templates/$templateKey"
      preLoaderRoute: typeof AuthedAdminEmailTemplatesTemplateKeyRouteImport
      parentRoute: typeof AuthedAdminEmailTemplatesRoute
    }
    "/_authed/work/lodging/$id/invoice": {
      id: "/_authed/work/lodging/$id/invoice"
      path: "/invoice"
      fullPath: "/work/lodging/$id/invoice"
      preLoaderRoute: typeof AuthedWorkLodgingIdInvoiceLazyRouteImport
      parentRoute: typeof AuthedWorkLodgingIdLazyRoute
    }
    "/_authed/admin/uren/$entryId/edit": {
      id: "/_authed/admin/uren/$entryId/edit"
      path: "/$entryId/edit"
      fullPath: "/admin/uren/$entryId/edit"
      preLoaderRoute: typeof AuthedAdminUrenEntryIdEditRouteImport
      parentRoute: typeof AuthedAdminUrenRoute
    }
  }
}

interface AuthedWorkNewRouteRouteChildren {
  AuthedWorkNewTypeRoute: typeof AuthedWorkNewTypeRoute
  AuthedWorkNewNoWorkLazyRoute: typeof AuthedWorkNewNoWorkLazyRoute
  AuthedWorkNewTravelLazyRoute: typeof AuthedWorkNewTravelLazyRoute
  AuthedWorkNewWorkLazyRoute: typeof AuthedWorkNewWorkLazyRoute
}

const AuthedWorkNewRouteRouteChildren: AuthedWorkNewRouteRouteChildren = {
  AuthedWorkNewTypeRoute: AuthedWorkNewTypeRoute,
  AuthedWorkNewNoWorkLazyRoute: AuthedWorkNewNoWorkLazyRoute,
  AuthedWorkNewTravelLazyRoute: AuthedWorkNewTravelLazyRoute,
  AuthedWorkNewWorkLazyRoute: AuthedWorkNewWorkLazyRoute,
}

const AuthedWorkNewRouteRouteWithChildren =
  AuthedWorkNewRouteRoute._addFileChildren(AuthedWorkNewRouteRouteChildren)

interface AuthedWorkLodgingIdLazyRouteChildren {
  AuthedWorkLodgingIdInvoiceLazyRoute: typeof AuthedWorkLodgingIdInvoiceLazyRoute
}

const AuthedWorkLodgingIdLazyRouteChildren: AuthedWorkLodgingIdLazyRouteChildren =
  {
    AuthedWorkLodgingIdInvoiceLazyRoute: AuthedWorkLodgingIdInvoiceLazyRoute,
  }

const AuthedWorkLodgingIdLazyRouteWithChildren =
  AuthedWorkLodgingIdLazyRoute._addFileChildren(
    AuthedWorkLodgingIdLazyRouteChildren,
  )

interface AuthedWorkRouteRouteChildren {
  AuthedWorkNewRouteRoute: typeof AuthedWorkNewRouteRouteWithChildren
  AuthedWorkChangesRoute: typeof AuthedWorkChangesRoute
  AuthedWorkInboxRoute: typeof AuthedWorkInboxRoute
  AuthedWorkIndexRoute: typeof AuthedWorkIndexRoute
  AuthedWorkDayDateRoute: typeof AuthedWorkDayDateRoute
  AuthedWorkAttachmentsIdLazyRoute: typeof AuthedWorkAttachmentsIdLazyRoute
  AuthedWorkLodgingIdLazyRoute: typeof AuthedWorkLodgingIdLazyRouteWithChildren
  AuthedWorkTripIdLazyRoute: typeof AuthedWorkTripIdLazyRoute
}

const AuthedWorkRouteRouteChildren: AuthedWorkRouteRouteChildren = {
  AuthedWorkNewRouteRoute: AuthedWorkNewRouteRouteWithChildren,
  AuthedWorkChangesRoute: AuthedWorkChangesRoute,
  AuthedWorkInboxRoute: AuthedWorkInboxRoute,
  AuthedWorkIndexRoute: AuthedWorkIndexRoute,
  AuthedWorkDayDateRoute: AuthedWorkDayDateRoute,
  AuthedWorkAttachmentsIdLazyRoute: AuthedWorkAttachmentsIdLazyRoute,
  AuthedWorkLodgingIdLazyRoute: AuthedWorkLodgingIdLazyRouteWithChildren,
  AuthedWorkTripIdLazyRoute: AuthedWorkTripIdLazyRoute,
}

const AuthedWorkRouteRouteWithChildren = AuthedWorkRouteRoute._addFileChildren(
  AuthedWorkRouteRouteChildren,
)

interface AuthedAdminEmailTemplatesRouteChildren {
  AuthedAdminEmailTemplatesTemplateKeyRoute: typeof AuthedAdminEmailTemplatesTemplateKeyRoute
}

const AuthedAdminEmailTemplatesRouteChildren: AuthedAdminEmailTemplatesRouteChildren =
  {
    AuthedAdminEmailTemplatesTemplateKeyRoute:
      AuthedAdminEmailTemplatesTemplateKeyRoute,
  }

const AuthedAdminEmailTemplatesRouteWithChildren =
  AuthedAdminEmailTemplatesRoute._addFileChildren(
    AuthedAdminEmailTemplatesRouteChildren,
  )

interface AuthedAdminUrenRouteChildren {
  AuthedAdminUrenEntryIdEditRoute: typeof AuthedAdminUrenEntryIdEditRoute
}

const AuthedAdminUrenRouteChildren: AuthedAdminUrenRouteChildren = {
  AuthedAdminUrenEntryIdEditRoute: AuthedAdminUrenEntryIdEditRoute,
}

const AuthedAdminUrenRouteWithChildren = AuthedAdminUrenRoute._addFileChildren(
  AuthedAdminUrenRouteChildren,
)

interface AuthedRouteRouteChildren {
  AuthedWorkRouteRoute: typeof AuthedWorkRouteRouteWithChildren
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedAdminAddressesRoute: typeof AuthedAdminAddressesRoute
  AuthedAdminAppSettingsRoute: typeof AuthedAdminAppSettingsRoute
  AuthedAdminAuditLogRoute: typeof AuthedAdminAuditLogRoute
  AuthedAdminEmailTemplatesRoute: typeof AuthedAdminEmailTemplatesRouteWithChildren
  AuthedAdminHolidaysRoute: typeof AuthedAdminHolidaysRoute
  AuthedAdminReplacementsRoute: typeof AuthedAdminReplacementsRoute
  AuthedAdminStyleguideRoute: typeof AuthedAdminStyleguideRoute
  AuthedAdminTranslationsRoute: typeof AuthedAdminTranslationsRoute
  AuthedAdminUrenRoute: typeof AuthedAdminUrenRouteWithChildren
  AuthedAdminUsersRoute: typeof AuthedAdminUsersRoute
  AuthedOnboardingMfaRoute: typeof AuthedOnboardingMfaRoute
}

const AuthedRouteRouteChildren: AuthedRouteRouteChildren = {
  AuthedWorkRouteRoute: AuthedWorkRouteRouteWithChildren,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedAdminAddressesRoute: AuthedAdminAddressesRoute,
  AuthedAdminAppSettingsRoute: AuthedAdminAppSettingsRoute,
  AuthedAdminAuditLogRoute: AuthedAdminAuditLogRoute,
  AuthedAdminEmailTemplatesRoute: AuthedAdminEmailTemplatesRouteWithChildren,
  AuthedAdminHolidaysRoute: AuthedAdminHolidaysRoute,
  AuthedAdminReplacementsRoute: AuthedAdminReplacementsRoute,
  AuthedAdminStyleguideRoute: AuthedAdminStyleguideRoute,
  AuthedAdminTranslationsRoute: AuthedAdminTranslationsRoute,
  AuthedAdminUrenRoute: AuthedAdminUrenRouteWithChildren,
  AuthedAdminUsersRoute: AuthedAdminUsersRoute,
  AuthedOnboardingMfaRoute: AuthedOnboardingMfaRoute,
}

const AuthedRouteRouteWithChildren = AuthedRouteRoute._addFileChildren(
  AuthedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRouteRoute: AuthedRouteRouteWithChildren,
  SignInRoute: SignInRoute,
  SignOutRoute: SignOutRoute,
  TwoFactorRoute: TwoFactorRoute,
  OnboardingTokenRoute: OnboardingTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
